import React from 'react';

export const CustomXAxisTick = ({
    x,
    y,
    payload,
    maxAmountOfCharsPerLine,
    fontSize,
}: {
    x?: number;
    y?: number;
    payload?: { value: string };
    maxAmountOfCharsPerLine: number;
    fontSize: number;
}) => {
    const lines: string[] = splitTextInMultipleLines(payload?.value ?? '', maxAmountOfCharsPerLine);
    return (
        <g transform={`translate(${x},${y})`}>
            <text textAnchor="middle" fill="#666" fontSize={fontSize}>
                {lines.map((line, i) => (
                    <tspan key={i} x={0} dy={i === 0 ? 16 : 14}>
                        {line}
                    </tspan>
                ))}
            </text>
        </g>
    );
};

const splitTextInMultipleLines = (text: string, maxAmountOfCharsPerLine: number): string[] => {
    const words = text.split(' ');
    const lines: string[] = [];
    let currentLine = '';
    for (const word of words) {
        const line = currentLine ? `${currentLine} ${word}` : word;
        if (line.length > maxAmountOfCharsPerLine && currentLine) {
            lines.push(currentLine);
            currentLine = word;
        } else {
            currentLine = line;
        }
    }
    if (currentLine) lines.push(currentLine);
    return lines;
};
